;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import { UI_STYLE_PRIMARY_BLUE_BLACK } from "../../../../src/lib/constants"

const CustomButton = styled(Button)(() => ({
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
  backgroundColor: "white",
  border: "1px solid #092C3C",
  boxShadow: "none",
  height: "52px",
  width: "188px",
  display: "flex",
  justifyContent: "space-around",
  padding: "0 15px",
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "19px",
  textTransform: "unset",
  textAlign: "center",
  letterSpacing: "0.03em",
  borderRadius: "100px",
  margin: "0 5px",
  fontFamily: "var(--font-roboto)",
  "@media only screen and (min-width: 600px)": {
    fontSize: "16px",
    width: "213px",
    margin: "unset",
  },
  "&:hover": {
    backgroundColor: "rgb(0, 0, 0, 0.08)",
  },
}))

type ShareThisArticleButtonProps = {
  onClick: () => void
}

export default function ShareThisArticleButton({
  onClick,
}: ShareThisArticleButtonProps) {
  return (
    <CustomButton onClick={onClick}>
      <div>Share this article</div>
    </CustomButton>
  )
}
